import type { DatasetFileProps } from "./dataset-file.type";

import { DatasetCard } from "@/modules/dataset/dataset-card";

import DatasetFileEditor from "./dataset-file-editor";

const DatasetFile = ({
  template,
  dataset,
  loading,
  disabled,
}: DatasetFileProps) => {
  return (
    <DatasetCard
      datasetType="file"
      template={template}
      dataset={dataset}
      loading={loading}
      disabled={disabled}
    >
      <DatasetFileEditor
        template={template}
        dataset={dataset}
        disabled={disabled}
      />
    </DatasetCard>
  );
};

export default DatasetFile;
